export enum UserRelationship {
    None,
    Following,
    Follower,
    Friend
}
